// extracted by mini-css-extract-plugin
module.exports = {"container":"_1-TkBA mz-header-bar__title","supportedPlatforms":"t8mblG","downloadIcon":"_2iww_A"};